import { render } from "./AdminEconomy.vue?vue&type=template&id=26b9ef27&scoped=true"
import script from "./AdminEconomy.vue?vue&type=script&lang=js"
export * from "./AdminEconomy.vue?vue&type=script&lang=js"

import "./AdminEconomy.vue?vue&type=style&index=0&id=26b9ef27&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b9ef27"]])

export default __exports__